"use client";

import dynamic from "next/dynamic";

// Dynamically import MediaRenderer to avoid SSR issues with canvas package
const MediaRenderer = dynamic(() => import("./media-renderer").then(mod => ({ default: mod.default })), {
  ssr: false,
  loading: () => (
    <div className="flex h-full w-full items-center justify-center bg-muted">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-muted-foreground/20 border-t-muted-foreground/60"></div>
        <p className="mt-2 text-sm text-muted-foreground">Loading media...</p>
      </div>
    </div>
  ),
});

export { MediaRenderer };
